const isBlankValue = (value) => typeof value === "string" && !value.trim()

const isFiniteNumericValue = (value) => Number.isFinite(Number(value))

export const formatNumber = (value, maxDecimals = 2, locale = "pt-BR") => {
    if (value === null || value === undefined || isBlankValue(value) || !isFiniteNumericValue(value))
        return "-"
    return new Intl.NumberFormat(locale, {
        maximumFractionDigits: maxDecimals,
    }).format(value)
}

export const formatFixedDecimals = (value, decimals = 2, fallback = "-", locale = "pt-BR") => {
    if (value === null || value === undefined || isBlankValue(value) || !isFiniteNumericValue(value))
        return fallback
    return new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    }).format(value)
}

export const formatDecimalSeparator = (value, fallback = "-") => {
    if (value === null || value === undefined || isBlankValue(value)) {
        return fallback
    }

    const text = String(value).trim()
    if (!/^-?\d+(?:[.,]\d+)?$/.test(text)) return fallback

    return text.replace(".", ",")
}
